export default __webpack_public_path__ + "static/media/adudas-nmd-hu.acc8e798.jpg";